export default __webpack_public_path__ + "static/media/64.45593ad9.svg";